import styles from "./ModalSuccessQuestion.module.css";
import { useModal } from "../../hooks/useModalHook";

const ModalSuccessQuestion = () => {
  const { closeModal } = useModal();
  return (
    <div className={styles.modalInfo}>
      <h3 className={styles.titleModal}>Ваш вопрос успешно отправлен!</h3>
      <div className={styles.descriptionModal}>
        Наш администратор уже передал его врачу, и&nbsp;мы&nbsp;постараемся
        связаться с&nbsp;вами как можно скорее.
      </div>
      <button onClick={closeModal} className={styles.buttonModal}>
        Супер
      </button>
    </div>
  );
};

export default ModalSuccessQuestion;
